import React from 'react';
import {Box, Button} from "@mui/material";
const Constants = require("../constants/Constants");

const SubmitButton = () => {
    let IMAGE_URL = Constants.IMAGE_URL
    return    ( <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ p: 1 }}>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, maxWidth: "200px", border: 2, boxShadow: 6, borderColor:'black'}}
                    >
                        <img loading="lazy" src={`${IMAGE_URL}navigation/Submit.png`} style={{ width: "60%" }} alt="Submit Button" />
                    </Button>

                </Box>
    )
}

export default SubmitButton;
